import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import External from '../../../../asset/mama/external.png';
import TG from '../../../../asset/mama/tg.png';
import Viber from '../../../../asset/mama/viber.png';
import { i18n } from '../../../../lib/lang';
import { MamaTextLogo } from '../../container/home/frame/hero';
import { BackgroundImageHolder } from '../mama/page';

export const Page: React.FC<RouteComponentProps> = () => {
  const viberHref = i18n.t('MAMA.HOME.VIBER');
  const telegramHref = i18n.t('MAMA.HOME.TELEGRAM');
  const siteHref = i18n.t('MAMA.HOME.SITE');

  const options = [
    { href: telegramHref, src: TG, label: 'Telegram' },
    { href: viberHref, src: Viber, label: 'Viber' },
    { href: siteHref, src: External, label: 'Сайт' },
  ];

  return (
    <BackgroundImageHolder>
      <Layout>
        <Card>
          <MamaTextLogo size="heroMiddle" color='white'>Оберіть</MamaTextLogo>
          <OptionsGrid>
            {options.map(({ href, src, label }) => (
              <OptionLink key={label} href={href} target="_blank" rel="noopener noreferrer">
                <SocialIcon src={src} alt={label} />
                <OptionLabel>{label}</OptionLabel>
              </OptionLink>
            ))}
          </OptionsGrid>
        </Card>
      </Layout>
    </BackgroundImageHolder>
  );
};

const Layout = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
`;

const Card = styled.div`
  background: linear-gradient(180deg, #FF0480 0%, #97003C 100%);

  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 32px;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 500px;
  width: 100%;

  @media (max-width: 480px) {
    padding: 36px 24px;
    border-radius: 24px;
  }
`;

const Title = styled.h1`
  font-family: 'RF Dewi', sans-serif;
  font-weight: 800;
  font-size: 28px;
  color: #ffffff;
  margin: 0;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const OptionsGrid = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 20px;
`;

const OptionLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    opacity: 0.85;
  }

  &:active {
    transform: translateY(0px) scale(0.96);
  }
`;


const SocialIcon = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
`;

const OptionLabel = styled.span`
  font-family: 'RF Dewi', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
`;